var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 11,
    rx: 1.5,
    fill: "white",
    stroke: "#E08267"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05728 5.57153H3.943C3.8066 5.57153 3.67579 5.61669 3.57934 5.69706C3.48289 5.77743 3.42871 5.88644 3.42871 6.0001C3.42871 6.11377 3.48289 6.22278 3.57934 6.30315C3.67579 6.38352 3.8066 6.42868 3.943 6.42868H8.05728C8.19368 6.42868 8.32449 6.38352 8.42094 6.30315C8.51739 6.22278 8.57157 6.11377 8.57157 6.0001C8.57157 5.88644 8.51739 5.77743 8.42094 5.69706C8.32449 5.61669 8.19368 5.57153 8.05728 5.57153Z",
    fill: "#E08267"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelButton);
export default __webpack_public_path__ + "static/media/cancel_button.edec66e3d8e927ece00a7a0b541e5199.svg";
export { ForwardRef as ReactComponent };